class FbdClassPendingTooltip  {
   eGui;
   init(params) {
      const pending = params.value;
      this.eGui = document.createElement("div");

      if(Array.isArray(pending) && pending.length > 0) {
         this.eGui.classList.add("custom-tooltip", "roster-tooltip");

         let lastSpan = null;
         for (const pStudent of pending) {
            if(lastSpan) {
               const tn = document.createTextNode(', ');
               lastSpan.appendChild(tn);
            }

            const rSpan = document.createElement("span");
            rSpan.innerText = pStudent;

            this.eGui.appendChild(rSpan);

            lastSpan = rSpan;
         }
      }
   }

   getGui() {
      return this.eGui;
   }
}

export default FbdClassPendingTooltip;